import { render, staticRenderFns } from "./ResponseKP.vue?vue&type=template&id=ce8caa98&"
import script from "./ResponseKP.vue?vue&type=script&lang=js&"
export * from "./ResponseKP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports